import { ProtectedJsonAPI } from '.'

export const Opts = ProtectedJsonAPI.extend(
  '/oadr/opts',
  {
    show:    endpoint => endpoint.path(({id}) => id)
  }
)